import React from 'react'

// Two overlapping person-heads-and-shoulders shapes — the "buddy pair" idea,
// same rounded-square-tile-with-gradient convention as the other apps'
// AppIcon (see spa/src/apps/events/components/AppIcon).
export const AppIcon = () => (
  <svg width="100%" height="100%" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" style={{ fillRule: 'evenodd', clipRule: 'evenodd' }}>
    <path d="M64,16c0,-8.831 -7.169,-16 -16,-16l-32,0c-8.831,0 -16,7.169 -16,16l0,32c0,8.831 7.169,16 16,16l32,0c8.831,0 16,-7.169 16,-16l0,-32Z" fill="url(#buddy-icon-gradient)" />
    <circle cx="24" cy="26" r="9" fill="#fff" />
    <path d="M10,50c0,-7.732 6.268,-14 14,-14c7.732,0 14,6.268 14,14" fill="none" stroke="#fff" strokeWidth="5" strokeLinecap="round" />
    <circle cx="42" cy="22" r="7" fill="#fff" opacity="0.85" />
    <path d="M31,46c1.5,-5.5 6,-9 11,-9c6.075,0 11,4.925 11,11" fill="none" stroke="#fff" strokeWidth="5" strokeLinecap="round" opacity="0.85" />
    <defs>
      <linearGradient id="buddy-icon-gradient" x1="0" y1="0" x2="1" y2="0" gradientUnits="userSpaceOnUse" gradientTransform="matrix(64,64,-64,64,0,0)">
        <stop offset="0" style={{ stopColor: '#9AEBCF', stopOpacity: 1 }} />
        <stop offset="1" style={{ stopColor: '#B6CFFF', stopOpacity: 1 }} />
      </linearGradient>
    </defs>
  </svg>
)
